import * as api from '~services/api';

export const fetchAdEmails = ({ search }) => {
  return api.get(`ademailsearch?search=${search}`);
};
